import { Component } from '@angular/core';

@Component({
  selector: 'app-venue-view',
  imports: [],
  templateUrl: './venue-view.component.html',
  styleUrl: './venue-view.component.css'
})
export class VenueViewComponent {

}
